module.exports = __webpack_public_path__ + "img/logo-tws.3e7430d0.svg";